import { render, staticRenderFns } from "./rekoncakr.vue?vue&type=template&id=5e1c18bb"
import script from "./rekoncakr.vue?vue&type=script&lang=js"
export * from "./rekoncakr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports